export const makeSpinner = function (classAttr, wrapperClass = false) {
    if (typeof classAttr !== 'string'){
        classAttr = '';
    }

    let spinner = `<div class="lds-ring ${classAttr}"><div></div><div></div><div></div><div></div></div>`;
    if (wrapperClass){
        spinner = `<div class="${wrapperClass}">${spinner}</div>`;
    }
    return spinner
}
export const btnLoading = function (btn, loadingStatus) {
    if (true === loadingStatus) {
        btn.addClass('btn--is-loading');

        if (!btn.find('.lds-ring').length) {
            btn.prepend(makeSpinner());
        }

    } else {
        btn.removeClass('btn--is-loading')
    }

    btn.find('.lds-ring').addClass('lds-ring--btn');
}

